/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Table, Form, Grid, Segment, Accordion,
  Divider, Statistic, Icon, Popup, Dimmer,
  DimmerDimmable, Modal, Header, Button
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import InitLoader from "./login-config/InitLoader";
import Constants from "./utilities/Constants";
import Strings from "./utilities/StringSelector";
import Utils from "./utilities/Utils";

const UtilsInstance = new Utils();

const statusKeyArray = [Strings.GOOD_STRING, Strings.BAD_STRING, Strings.ATTENTION_STRING, Strings.FAULT_STRING];
const statusValueArray = [Constants.GOOD, Constants.BAD, Constants.ATTENTION, Constants.FAULT];

class LiveList extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      formInput: "",
      column: null,
      sortDirection: "ascending",
      originalDevices: [],
      devices: [],
      isColumnClicked: false,
      baudrate: 0,
      nMasters: 0,
      nSlaves: 0,
      errorMessages: [],
      firstScanFail: false,
      // loading
      percent: 100,
      channelTag: "",
      clickedDevice: "",
      showModal: false,
    };
    this.InitLoaderRef = React.createRef();
  }

  closeModal = () => this.setState({ showModal: false })

  handleModalDeleteClick = () => {
    this.setState({
      showModal: false,
    });
    this.removeFaultDevice(this.state.clickedDevice);
  }

  removeFaultDevice = (deviceAddress) => {
    let data = JSON.stringify({
      address: deviceAddress
    });

    fetch(Constants.REQUEST_IP_ADDRESS + "remove_POST/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.REMOVE_DEVICE_SUCCESS);
      })
      .catch((error) => {
        alert(Strings.REMOVE_DEVICE_FAILURE + "\n" + Strings.REASON_ASI + error);
      });
  }

  // Since the devices in ASi protocol are not numbered with simple integers
  // We need to convert, 1A and 1B for exemple, into sortable integers
  // Every device that has A in its address has its number as the sortable integer
  // Every device that has B in its addres, has its number + 32 as the sortable integer
  // Every device that has master in its name has its number be 0
  addOrderAndSeverityToDevices = (devices) => {
    let aRegExp = new RegExp("A");
    let bRegExp = new RegExp("B");

    for (let i = 0; i < devices.length; i++) {
      // Adding severity level
      if (devices[i].status === Constants.FAULT) {
        devices[i].severity = 5;
      } else if (devices[i].status === Constants.BAD) {
        devices[i].severity = 4;
      } else if (devices[i].status === Constants.ATTENTION) {
        devices[i].severity = 3;
      } else if (devices[i].status === Constants.GOOD) {
        devices[i].severity = 2;
      } else {
        devices[i].severity = 1;
      }

      // Adding order value
      let deviceName = devices[i].address;

      if (deviceName.includes("A")) {
        devices[i].order = parseInt(deviceName.replace(aRegExp, ""));
      }
      else if (deviceName.includes("B")) {
        devices[i].order = parseInt(deviceName.replace(bRegExp, "")) + 32;
      }
      else if (UtilsInstance.treatUppercase(deviceName) === UtilsInstance.treatUppercase(Strings.MASTER)) {
        devices[i].order = 0;
      }
      else {
        devices[i].order = parseInt(deviceName);
      }
    }

    devices.sort(UtilsInstance.sortBy("order", false, parseInt));
  }

  // Sorts the table when the user clicks on one of the columns
  handleSort = clickedColumn => () => {

    this.setState({
      isColumnClicked: true
    });

    // The user wants to order the live list by address ascending
    if (clickedColumn === "address" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "order",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by address descending
    else if (clickedColumn === "address" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "order",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by amplitude ascending
    else if (clickedColumn === "amplitude" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "amplitude",
            false,
            parseFloat)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by amplitude descending
    else if (clickedColumn === "amplitude" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "amplitude",
            true,
            parseFloat)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by noise ascending
    else if (clickedColumn === "noise" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "noise",
            false,
            parseFloat)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by noise descending
    else if (clickedColumn === "noise" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "noise",
            true,
            parseFloat)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by deviation ascending
    else if (clickedColumn === "deviation" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "deviation",
            false,
            parseFloat)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by deviation descending
    else if (clickedColumn === "deviation" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "deviation",
            true,
            parseFloat)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by status ascending
    else if (clickedColumn === "status" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "severity",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by status descending
    else if (clickedColumn === "status" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "severity",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by data exchange ascending
    else if (clickedColumn === "dataExchange" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "dataExchange",
            false,
            function (a) { return a; })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by data exchange descending
    else if (clickedColumn === "dataExchange" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "dataExchange",
            true,
            function (a) { return a; })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by fault ascending
    else if (clickedColumn === "fault" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "fault",
            false,
            function (a) { return a; })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by fault descending
    else if (clickedColumn === "fault" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "fault",
            true,
            function (a) { return a; })),
        sortDirection: "ascending",
      });
    }
    else if (clickedColumn === "retry" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "retry",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by address descending
    else if (clickedColumn === "retry" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "retry",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
  }

  // Creates a list with entries that match the address passed on the form
  handleAddressSearch = () => {
    const searchedDevices = [];

    for (let i = 0; i < this.state.originalDevices.length; i++) {
      if (this.state.originalDevices[i].address.toUpperCase() === this.state.formInput.toUpperCase()) {
        searchedDevices.push(this.state.originalDevices[i]);
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  // Creates a list with entries that match the status passed on the form
  handleStatusSearch = (statusArray) => {
    const searchedDevices = [];

    for (let i = 0; i < statusArray.length; i++) {
      for (let j = 0; j < this.state.originalDevices.length; j++) {
        if (this.state.originalDevices[j].status === statusArray[i]) {
          searchedDevices.push(this.state.originalDevices[j]);
        }
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  /*
    If the user typed a substring of one of the possible status: (In uppercase, lowercase or a mix of them)
    it returns and array containing the indexes to match against the json received from the server
  */
  matchFormInputStatus = () => {
    let matchedArray = [-1];
    let matchedIndex = 0;

    for (let i = 0; i < statusKeyArray.length; i++) {
      // Uppercases the user input before comparison to allow for a more flexible search
      // It doesn't matter if the user typed in uppercase, lowercase or any combination of them
      const status = statusKeyArray[i].toUpperCase();
      const upperCaseUserInput = this.state.formInput.toUpperCase();
      if (status.indexOf(upperCaseUserInput) !== -1) {
        matchedArray[matchedIndex] = i;
        matchedIndex++;
      }
    }

    return matchedArray;
  }

  /*
    Filters the page list showing only the devices that match the address or status typed in the form
  */
  handleSubmit = () => {
    const matchValueArray = this.matchFormInputStatus();
    let auxArray = [];

    for (let i = 0; i < matchValueArray.length; i++) {
      auxArray.push(statusValueArray[matchValueArray[i]]);
    }

    if (this.state.formInput !== "" && matchValueArray[0] !== -1) {
      this.handleStatusSearch(auxArray);
    }
    else if (this.state.formInput === "") {
      this.setState({ devices: this.state.originalDevices });
    }
    // If what the user typed is not a status and the form is not blank, try to see if he typed a number
    else {
      this.handleAddressSearch();
    }
  }

  retrieveData = async () => {
    // Retrieve devices list only if the input form is empty and the user didn't 
    // sort the table by clicking a column header
    if (this.state.formInput === "" && !this.state.isColumnClicked) {
      let promissesArray = [];

      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS + "liveList/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
          .then(res => res.json())
          .then(data => data)
          .catch((error) => {
            console.log(error);
          })
      );

      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS + "networkData/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
          .then(res => res.json())
          .then(data => data)
          .catch((error) => {
            console.log(error);
          })
      );

      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS + "warnings/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
          .then(res => res.json())
          .then(data => data)
      );

      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS + "getChannelTagsAndNotes/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
          .then(res => res.json())
          .then(data => data.tag)
      );


      let resolvedPromisses = await Promise.all(promissesArray);

      let liveList = resolvedPromisses[0];
      let networkData = resolvedPromisses[1];
      let warnings = resolvedPromisses[2];
      let channelTag = resolvedPromisses[3];
      this.addOrderAndSeverityToDevices(liveList);

      this.setState({
        devices: liveList,
        originalDevices: liveList,
        // Network Data
        baudrate: networkData.baudrate,
        nMasters: networkData.nMasters,
        nSlaves: networkData.nSlaves,
        // Warnings
        InitPicoNotFound: warnings.InitPicoNotFound,
        firstScanFail: warnings.firstScanFail,
        channelTag: channelTag
      });

    }
  }

  retrievePercentData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "getCurrentPercent/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({ percent: data.percent }, () => {
        if (this.state.percent < 100) {
          this.InitLoaderRef.current.changeLoaderText(
            <>
              <p>
                {Strings.INITIALIZING_SCOPE_DP}<br />
                {Strings.LOADING}: {this.state.percent}%
              </p>
            </>
          );
        }
      }));
  }

  handleLineClick = (address) => () => {
    this.setState({ clickedDevice: address}, () => {
      this.setState({ showModal: true });
    });
  }

  /* 
    Create Status Cell
    parameters: 
    - device: JSON information of the device being added to the table
    - return: A new table cell stylized according to the current device status
  */
  createStatusCell = (device) => {
    if (device.status === Constants.GOOD) {
      return (
        <Table.Cell
          selectable
          width={2}
          style={okCellStyle}>
          {Strings.GOOD_STRING}
        </Table.Cell>
      );
    }
    else if (device.status === Constants.ATTENTION) {
      return (
        <Table.Cell
          selectable
          width={2}
          style={attentionCellStyle}>
          {Strings.ATTENTION_STRING}
        </Table.Cell>
      );
    }
    else if (device.status === Constants.BAD) {
      return (
        <Table.Cell
          selectable
          width={2}
          style={badCellStyle}>
          {Strings.BAD_STRING}
        </Table.Cell>
      );
    }
    else if (device.status === Constants.FAULT) {
      return (
        <Table.Cell
          selectable
          width={2}
          style={faultCellStyle}
          onClick={this.handleLineClick(device.address)}>
          {Strings.FAULT_STRING}
        </Table.Cell>
      );
    }
    else {
      return (
        <Table.Cell
          selectable
          width={2}
          style={unknownCellStyle}>
          {Strings.UNKNOWN_STRING}
        </Table.Cell>
      );
    }
  }

  /*
    Adjusts the size of the table so that it does not exceed the
    browser window height limit
  */
  adjustTableMaxHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    let newTableMaxHeight = browserHeight * Constants.SCALING_FACTOR_LIVE_TOPOLOGY;
    newTableMaxHeight = newTableMaxHeight.toString();
    newTableMaxHeight = newTableMaxHeight.concat("px");
    document.getElementById("main-table-container").style["maxHeight"] = newTableMaxHeight;
  }

  /*
    Saves the form input to the component state everytime the user
    types something in the form
  */
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  retrieveWarnings = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "warnings/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
      .then(res => res.json())
      .then(data => { this.handleWarningMessages(data); });
  }

  handleWarningMessages = (errors) => {
    let errorMessages = [];

    if (errors.scanFail || errors.picoNotFound || errors.invertedPolarity) {
      // If at least one of the errors above ocurred, unhide the error message's container
      if (document.getElementById("message-list") !== undefined
        && document.getElementById("message-list") !== null) {
        document.getElementById("message-list").style.display = "block";
      }

      if (errors.InitPicoNotFound) {
        errorMessages.push(Strings.INIT_PICO_NOT_FOUND);
      }

      if (errors.firstScanFail) {
        errorMessages.push(Strings.NO_ACTIVE_NETWORK);
      }

      if (errors.mongoOFF) {
        errorMessages.push(Strings.MONGO_OFF);
      }

      if (errors.picoNotFound) {
        errorMessages.push(Strings.PICO_NOT_FOUND);
      }

      if (errors.scanFail) {
        errorMessages.push(Strings.SCAN_FAIL_FOUND);
      }

      if(errors.invertedPolarity) {
        errorMessages.push(Strings.INVERTED_POLARITY_FOUND);
      }

      this.setState({ errorMessages: errorMessages });
    }
    else {

      if (document.getElementById("message-list") !== undefined
        && document.getElementById("message-list") !== null) {
        document.getElementById("message-list").style.display = "none";
      }

      if (document.getElementById("repair-button") !== undefined
        && document.getElementById("repair-button") !== null) {
        document.getElementById("repair-button").style.display = "none";
      }

      this.setState({ errorMessages: [] });
    }
  }

  createDeviationCell = (device) => {
    if (device.nonStandardDeviation) {
      return (
        <Table.Cell
          style={nonStdDeviationCellStyle}
          width={2}
          verticalAlign="middle">
          {device.deviation.toFixed(2).replace(".", ",") + Strings.MICROSSECOND}
        </Table.Cell>
      );
    }
    else {
      return (
        <Table.Cell
          width={2}
          verticalAlign="middle">
          {device.deviation.toFixed(2).replace(".", ",") + Strings.MICROSSECOND}
        </Table.Cell>
      );
    }
  }

  getAmplitudeText = (amplitude) => {
    return amplitude.toFixed(2).replace(".", ",") + Strings.VOLTAGE_PEAK_TO_PEAK;
  }

  getIvalue = (i) => {
    if (i === null) {
      return "-";
    }
    else {
      return i;
    }
  }

  getRetryValue = (retry) => {
    if (retry === -1) {
      return "-";
    }
    else {
      return retry;
    }
  }

  /// ---------------- Errors Accordion -----------------------------
  handleAccordionClick = (e, titleProps) => {
    const { index } = titleProps;
    const { accordionIndex } = this.state;
    const newIndex = accordionIndex === index ? -1 : index;

    this.setState({ accordionIndex: newIndex });
  };

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    //console.log("Live List / channel: ", parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)));
    this.retrieveData();
    this.retrieveWarnings();
    this.retrievePercentData();
    // store intervalId in the state so it can be accessed later
    this.setState({
      intervalID: setInterval(this.retrieveData, 1000),
      warningsIntervalID: setInterval(this.retrieveWarnings, 5000),
      percentIntervalID: setInterval(this.retrievePercentData, 5000)
    });
    this.adjustTableMaxHeight();
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
    clearInterval(this.state.warningsIntervalID);
    clearInterval(this.state.percentIntervalID);
  }

  componentDidUpdate() {
    this.adjustTableMaxHeight();
  }

  // Render the table containing all network devices
  render() {
    const column = this.state.column;
    const direction = this.state.sortDirection;
    const filter = this.state.formInput;

    const devices = this.state.devices.map(device => (
      <Table.Row key={device.address} textAlign="center">
        <Table.Cell width={2} verticalAlign="middle">{device.address}</Table.Cell>
        <Table.Cell width={2} verticalAlign="middle">{device.tag}</Table.Cell>
        <Table.Cell width={2} verticalAlign="middle">{this.getAmplitudeText(device.amplitude)}</Table.Cell>
        {this.createDeviationCell(device)}
        <Table.Cell width={2} verticalAlign="middle">{this.getAmplitudeText(device.noise)}</Table.Cell>
        <Table.Cell width={2} verticalAlign="middle">{this.getRetryValue(device.retry)}</Table.Cell>
        <Table.Cell width={1} verticalAlign="middle">{this.getIvalue(device.I0)}</Table.Cell>
        <Table.Cell width={1} verticalAlign="middle">{this.getIvalue(device.I1)}</Table.Cell>
        <Table.Cell width={1} verticalAlign="middle">{this.getIvalue(device.I2)}</Table.Cell>
        <Table.Cell width={1} verticalAlign="middle">{this.getIvalue(device.I3)}</Table.Cell>
        {this.createStatusCell(device)}
      </Table.Row>
    ));

    return (
      <DimmerDimmable style={dimmerStyle} as="div" dimmed={(this.state.percent < 100)}>

        <Grid style={gridStyle} columns={3} verticalAlign="middle" doubling>
          <Grid.Row>
            <Grid.Column>
            </Grid.Column>

            <Grid.Column>
              <Form onSubmit={this.handleSubmit} >
                <Form.Input
                  id="inputform"
                  placeholder={Strings.LIVE_LIST_INPUT_TEXT_PLACEHOLDER}
                  icon="search"
                  name="formInput"
                  value={filter}
                  onChange={this.handleChange} />
              </Form>
            </Grid.Column>

            <Grid.Column>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Grid style={gridStyle} columns={2} doubling>
          <Grid.Row>

            <Grid.Column width={3}>
              <Segment>
                <Divider horizontal style={dividerStyle}>{Strings.NETWORK_DATA}</Divider>
                <Statistic.Group widths={1} size="mini">
                  <Statistic>
                    <Statistic.Value>{Constants.ASI_BAUD_RATE}</Statistic.Value>
                    <Statistic.Label>{Strings.BAUD_RATE_KBPS}</Statistic.Label>
                  </Statistic>
                  <Statistic>
                    <Statistic.Value>{this.state.nMasters}</Statistic.Value>
                    <Statistic.Label>{Strings.MASTERS}</Statistic.Label>
                  </Statistic>
                  <Statistic>
                    <Statistic.Value>{this.state.nSlaves}</Statistic.Value>
                    <Statistic.Label>{Strings.SLAVES}</Statistic.Label>
                  </Statistic>
                  <Statistic>
                    <Statistic.Value>{parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL))}</Statistic.Value>
                    <Statistic.Label>{Strings.CURRENT_CHANNEL}</Statistic.Label>
                  </Statistic>
                  <Statistic>
                    <Statistic.Value>{this.state.channelTag}</Statistic.Value>
                    <Statistic.Label>{Strings.CHANNEL_TAG_STR}</Statistic.Label>
                  </Statistic>
                </Statistic.Group>
              </Segment>

              <Accordion id="message-list" styled style={accordionStyle}>
                <Accordion.Title
                  style={accordionTitleStyle}
                  active={this.state.accordionIndex === 1}
                  index={1}
                  onClick={this.handleAccordionClick}
                >
                  <Icon name="exclamation triangle" />
                  {Strings.DETECTED_PROBLEMS}
                  <Icon name="dropdown" />
                </Accordion.Title>
                <Accordion.Content active={this.state.accordionIndex === 1}>
                  <div style={accordionListItemsStyle}>
                    <ul style={{ paddingLeft: 0 }}>
                      {this.state.errorMessages.map((message) => (
                        <li key={message}>{message}</li>
                      ))}
                    </ul>
                  </div>
                </Accordion.Content>
              </Accordion>

            </Grid.Column>

            <Grid.Column width={13}>
              <Table id="table-header" style={headerMarginStyle} sortable striped celled fixed singleLine selectable textAlign="center">
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell
                      width={2}
                      sorted={column === "address" ? direction : null}
                      onClick={this.handleSort("address")}>
                      {Strings.ADDRESS}
                    </Table.HeaderCell>

                    <Table.HeaderCell
                      width={2}
                      sorted={column === "tag" ? direction : null}
                      onClick={this.handleSort("tag")}>
                      {Strings.TAG}
                    </Table.HeaderCell>

                    <Popup position='bottom center' hoverable pinned
                      trigger={
                        <Table.HeaderCell
                          width={2}
                          sorted={column === "amplitude" ? direction : null}
                          onClick={this.handleSort("amplitude")}>
                          {Strings.AMPLITUDE}
                          <span style={spanStyle}>
                            <Icon name="info circle" color="teal" />
                          </span>
                        </Table.HeaderCell>
                      }>
                      <Popup.Content>
                        <p>{Strings.AMPLITUDE_POPUP_STR1}</p>
                        <p>{Strings.AMPLITUDE_POPUP_STR2}</p>
                      </Popup.Content>
                    </Popup >

                    <Popup position='bottom center' hoverable pinned
                      trigger={
                        <Table.HeaderCell
                          width={2}
                          sorted={column === "deviation" ? direction : null}
                          onClick={this.handleSort("deviation")}>
                          {Strings.DEVIATION}
                          <span style={questionIconStyle}>
                            <Icon name="info circle" color="teal" />
                          </span>
                        </Table.HeaderCell>
                      }>
                      <Popup.Content>
                        <p>{Strings.DEV_POPUP_STR1}</p>
                        <p>{Strings.DEV_POPUP_STR2}</p>
                        <p>{Strings.DEV_POPUP_STR3}</p>
                      </Popup.Content>
                    </Popup >

                    <Popup position='bottom center' hoverable pinned
                      trigger={
                        <Table.HeaderCell
                          width={2}
                          sorted={column === "noise" ? direction : null}
                          onClick={this.handleSort("noise")}>
                          {Strings.NOISE}
                          <span style={questionIconStyle}>
                            <Icon name="info circle" color="teal" />
                          </span>
                        </Table.HeaderCell>
                      }>
                      <Popup.Content>
                        {Strings.NOISE_POPUP_STR}
                      </Popup.Content>
                    </Popup >

                    <Popup position='bottom center' hoverable pinned wide
                      trigger={
                        <Table.HeaderCell
                          width={2}
                          sorted={column === "retry" ? direction : null}
                          onClick={this.handleSort("retry")}>
                          {Strings.RETRIES}
                          <span style={spanStyle}>
                            <Icon name="info circle" color="teal" />
                          </span>
                        </Table.HeaderCell>
                      }>
                      <Popup.Content>
                        <p>{Strings.RETRIES_POPUP_STR_1}</p>
                        <p>{Strings.RETRIES_POPUP_STR_2}</p>
                      </Popup.Content>
                    </Popup >

                    <Popup position='bottom center' hoverable pinned
                      trigger={
                        <Table.HeaderCell disabled width={1}>
                          {Strings.I0}
                          <span style={spanStyle}>
                            <Icon name="info circle" color="teal" />
                          </span>
                        </Table.HeaderCell>
                      }>
                      <Popup.Content>
                        <p>{Strings.I_POPUP_STR}</p>
                      </Popup.Content>
                    </Popup >

                    <Popup position='bottom center' hoverable pinned
                      trigger={
                        <Table.HeaderCell disabled width={1}>
                          {Strings.I1}
                          <span style={spanStyle}>
                            <Icon name="info circle" color="teal" />
                          </span>
                        </Table.HeaderCell>
                      }>
                      <Popup.Content>
                        <p>{Strings.I_POPUP_STR}</p>
                      </Popup.Content>
                    </Popup >

                    <Popup position='bottom center' hoverable pinned
                      trigger={
                        <Table.HeaderCell disabled width={1}>
                          {Strings.I2}
                          <span style={spanStyle}>
                            <Icon name="info circle" color="teal" />
                          </span>
                        </Table.HeaderCell>
                      }>
                      <Popup.Content>
                        <p>{Strings.I_POPUP_STR}</p>
                      </Popup.Content>
                    </Popup >

                    <Popup position='bottom center' hoverable pinned
                      trigger={
                        <Table.HeaderCell disabled width={1}>
                          {Strings.I3}
                          <span style={spanStyle}>
                            <Icon name="info circle" color="teal" />
                          </span>
                        </Table.HeaderCell>
                      }>
                      <Popup.Content>
                        <p>{Strings.I_POPUP_STR}</p>
                      </Popup.Content>
                    </Popup >

                    <Popup position='bottom right' hoverable pinned wide
                      trigger={
                        <Table.HeaderCell
                          width={2}
                          sorted={column === "status" ? direction : null}
                          onClick={this.handleSort("status")}>
                          {Strings.STATUS}
                          <span style={spanStyle}>
                            <Icon name="info circle" color="teal" />
                          </span>
                        </Table.HeaderCell>
                      }>
                      <Popup.Content style={{ textAlign: "center", fontSize: "10pt" }}>
                        <div>
                          <p style={popupTitleStyle}>{Strings.STATUS_POPUP_STR_1}</p>
                          <div style={popupTitleStyle}>{Strings.GOOD_STRING}</div>
                          {Strings.STATUS_POPUP_STR_2}<sub>pp</sub>
                          <div style={popupTitleStyle}>{Strings.ATTENTION_STRING}</div>
                          {Strings.STATUS_POPUP_STR_3}<sub>pp</sub><br />
                          <div style={popupTitleStyle}>{Strings.BAD_STRING}</div>
                          {Strings.STATUS_POPUP_STR_4}<sub>pp</sub>{Strings.STATUS_POPUP_STR_5}<sub>pp</sub>
                          <div style={popupTitleStyle}>{Strings.FAULT_STRING}</div>
                          {Strings.STATUS_POPUP_STR_6}
                        </div>
                      </Popup.Content>
                    </Popup >

                  </Table.Row>
                </Table.Header>
              </Table>

              <div id="main-table-container" style={tableStyle}>
                <Table id="main-table" sortable striped celled fixed selectable textAlign="center" columns={7}>
                  <Table.Body>{devices}</Table.Body>
                </Table>

                <Modal centered open={this.state.showModal} onClose={this.closeModal} basic size='small'>
                  <Header icon='trash' content={Strings.REMOVE_POSITIONING} />
                  <Modal.Content>
                    <p>{Strings.REMOVE_DEVICE_MODAL_CONTENT_1}</p>
                    {/* <p><b>{Strings.PS}</b> {Strings.REMOVE_LOST_IP_MODAL_CONTENT_2}</p> */}
                  </Modal.Content>
                  <Modal.Actions>
                    <Button color='red' inverted onClick={this.closeModal}><Icon name='remove' />{Strings.NO}</Button>
                    <Button color='green' inverted onClick={this.handleModalDeleteClick}><Icon name='checkmark' />{Strings.YES}</Button>
                  </Modal.Actions>
                </Modal>
              </div>

            </Grid.Column>

          </Grid.Row>
        </Grid>

        <Dimmer inverted active={(this.state.percent < 100)}>
          <InitLoader ref={this.InitLoaderRef} />
        </Dimmer>
      </DimmerDimmable>
    );
  }
}

const mapStateToProps = state => ({
  channel: state.activeMenuItem.channel
});

// CSS custom table stylization
const gridStyle = {
  marginLeft: "2vw",
  marginRight: "2vw"
};

const tableStyle = {
  overflowY: "scroll"
};

const headerMarginStyle = {
  marginBottom: "1vh",
  width: "99.4%"
};

const okCellStyle = {
  color: "black",
  backgroundColor: "lime",
  verticalAlign: "middle"
};

const attentionCellStyle = {
  color: "black",
  backgroundColor: "yellow",
  verticalAlign: "middle"
};

const badCellStyle = {
  color: "black",
  backgroundColor: "#FF5722",
  verticalAlign: "middle"
};

const faultCellStyle = {
  color: "black",
  backgroundColor: "red",
  verticalAlign: "middle"
};

const unknownCellStyle = {
  color: "black",
  backgroundColor: "lightgrey",
  verticalAlign: "middle"
};

const nonStdDeviationCellStyle = {
  backgroundColor: "#ff6600"
};

const dividerStyle = {
  marginTop: "-0.2vh"
};

const questionIconStyle = {
  marginLeft: "4px"
};

const spanStyle = {
  float: "right"
};

const accordionStyle = {
  color: "#9F3A38",
  backgroundColor: "#FFF6F6",
  display: "none",
  marginBottom: "2vh",
};

const accordionTitleStyle = {
  color: "#9F3A38",
  textAlign: "center"
};

const accordionListItemsStyle = {
  textAlign: "left",
  listStylePosition: "inside",
};

const dimmerStyle = {
  zIndex: 1
};

const popupTitleStyle = {
  fontWeight: "bold"
};

export default connect(mapStateToProps)(withRouter(LiveList));